module.exports = __webpack_public_path__ + "img/customer.f9001cf3.svg";